import c from './Landing.module.css';
import { MORE_PLATFORMS, PRODUCTS, Product, Stage, WorkKind } from './data';

const STAGE_CLASS: Record<Stage, string> = {
  client: c.stageClient,
  production: c.stageProduction,
  beta: c.stageBeta,
  lab: c.stageLab,
};

const KIND_CLASS: Record<WorkKind, string> = {
  client: c.badgeClient,
  own: c.badgeOwn,
};

function ProductCard({ p }: { p: Product }) {
  const media = p.images ? (
    <div className={`${c.cardMedia} ${c.cardMediaLight}`}>
      <div className={c.strip} role="img" aria-label={p.imageAlt}>
        {p.images.map((src) => <img key={src} className={c.stripPanel} src={src} alt="" />)}
      </div>
    </div>
  ) : (
    <div className={c.cardMedia}>
      <img className={c.cardImg} src={p.image} alt={p.imageAlt} />
    </div>
  );
  const body = (
    <div className={c.cardBody}>
      <div className={c.cardIndex}>{p.index}</div>
      <div className={c.cardTitleRow}>
        <h3 className={c.h3}>{p.name}</h3>
        <span className={`${c.badge2} ${KIND_CLASS[p.kind]}`}><span />{p.status}</span>
      </div>
      <div className={c.cardTagline}>
        "{p.taglineLead} <span className={c.gradientText}>{p.taglineAccent}</span>"
      </div>
      <p className={c.cardText}>{p.description}</p>
      <div className={c.tags}>
        {p.tags.map((t) => <span key={t} className={c.tag}>{t}</span>)}
      </div>
      {p.url && (
        <a href={p.url} target="_blank" rel="noreferrer" className={c.cardLink}>{p.urlLabel}</a>
      )}
    </div>
  );

  return (
    <article className={`${c.card} ${p.layout === 'imageFirst' ? c.imageFirst : c.textFirst}`}>
      {p.layout === 'imageFirst' ? <>{media}{body}</> : <>{body}{media}</>}
    </article>
  );
}

export function Products() {
  return (
    <section id="work" className={`${c.container} ${c.section}`}>
      <div className={c.sectionHead}>
        <div>
          <div className={c.eyebrow}>01 — SELECTED WORK</div>
          <h2 className={c.h2}>Client work and <span className={c.gradientText}>our own platforms.</span></h2>
        </div>
        <span className={c.sectionMeta}>SELECTED WORK / 2026</span>
      </div>
      <div className={c.cards}>
        {PRODUCTS.map((p) => <ProductCard key={p.name} p={p} />)}
      </div>

      <div className={c.moreHead}>
        <div className={c.eyebrow}>MORE OF OUR OWN PLATFORMS</div>
        <p className={c.moreBlurb}>Products we build and operate ourselves, shown at their current stage.</p>
      </div>
      <div className={c.moreGrid}>
        {MORE_PLATFORMS.map((m) => (
          <article key={m.name} className={c.moreCard}>
            <div className={c.moreTitleRow}>
              <h4 className={c.h4}>{m.name}</h4>
              <span className={`${c.stage} ${STAGE_CLASS[m.stage]}`}><span />{m.stageLabel}</span>
            </div>
            <p className={c.moreText}>{m.blurb}</p>
            <div className={c.tags}>
              {m.tags.map((t) => <span key={t} className={c.tag}>{t}</span>)}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
